import React, { useState, useEffect, useContext } from "react";
import TreeMenu from "react-simple-tree-menu";
import { KTSVG, toAbsoluteUrl } from "../../../../helpers";
import { pushRotate as Menu } from "react-burger-menu";
import { useHistory } from "react-router-dom";
import "react-simple-tree-menu/dist/main.css";
import AppContext from "../../../../Context/AppContext";
import requestAxios from "../../../../util/requestAxios";
import MenuNavItem from "./MenuNavItem";
import "./MenuNav.css";

const MenuNav = () => {
  const [treeData, setNodeList] = useState([]);
  const { checkUserSession } = useContext(AppContext);
  const infoUs = checkUserSession();
  const history = useHistory();
  const [subMenuReportes, setSubMenuReportes] = useState(false);
  return (
    <div className="MenuNav__container">
      <div className="MenuSide__Container">
        <img
          className="imgLogoMenuHeader"
          src={toAbsoluteUrl("/img/Menu/logo-1-dark-01.png")}
        />
        <div className="MenuItem" onClick={() => history.push("/inicio")}>
          <KTSVG
            path={"/img/Menu/inicio.svg"}
            className={"iconMenuItem icon"}
          />
          Inicio
        </div>
        <div className="MenuHeaderCategory">MENÚ</div>
        <div className="MenuItem" onClick={() => history.push("/Acreditados")}>
          <KTSVG
            path={"/img/Menu/acreditados.svg"}
            className={"iconMenuItem icon"}
          />
          Acreditados
        </div>
        <div className="MenuItem" onClick={() => history.push("/Demandas")}>
          <KTSVG
            path={"/img/Menu/demandas.svg"}
            className={"iconMenuItem icon"}
          />
          Demandas
        </div>
        <div className="MenuItem" onClick={() => history.push("/MiActividad")}>
          <KTSVG
            path={"/img/Menu/miactividad.svg"}
            className={"iconMenuItem icon"}
          />
          Mi actividad
        </div>
        <div className="MenuItem" onClick={() => history.push("/MiPerfil")}>
          <KTSVG
            path={"/img/Menu/editarperfil.svg"}
            className={"iconMenuItem icon"}
          />
          Editar Perfil
        </div>
        <div
          className="MenuItem"
          onClick={() => {
            setSubMenuReportes(!subMenuReportes);
          }}
        >
          <KTSVG
            path={"/img/Menu/centroimpresion.svg"}
            className={"iconMenuItem icon"}
          />
          Centro de impresión
        </div>
        {subMenuReportes && (
          <>
            <div
              className="SubMenuItem"
              onClick={() => window.location.href=("/CentroImpresion/CasosJudiciales")}
            >
              Casos Judiciales
            </div>
            <div
              className="SubMenuItem"
              onClick={() => window.location.href=("/CentroImpresion/PagosMes")}
            >
              Pagos del mes
            </div>
            <div
              className="SubMenuItem"
              onClick={() =>
                window.location.href=("/CentroImpresion/AcreditadoIndividual")
              }
            >
              Ficha de Visita  
            </div>
            <div
              className="SubMenuItem"
              onClick={() => window.location.href=("/RelacionAcreditados")}
            >
              Relacion  de Acreditados
            </div>
            <div
              className="SubMenuItem"
              onClick={() => window.location.href=("/CentroImpresion/CarteraAsignada")}
            >
              Relacion sencilla de Cartera Asignada al Gestor
            </div>
          </>
        )}
       { /* 
        <div className="MenuItem" onClick={() => history.push("/GestionesMasivas")}>
          <KTSVG
            path={"/img/Menu/editarperfil.svg"}
            className={"iconMenuItem icon"}
          />
          Captruar Gestiones Masivas
        </div>
      */}
        <hr className="MenuLine" />
        <div className="MenuItem">
          <KTSVG
            path={"/img/Menu/Version.svg"}
            className={"iconMenuItem icon"}
          />
          Versión {process.env.REACT_APP_VERSION}
        </div>
      </div>
      {/* <Menu width={"280px"} pushRotate>
        <TreeMenu data={treeData} hasSearch>
          {({ search, items }) => (
            <ul>
              {items.map(({ key, ...props }) => (
                <MenuNavItem key={key} {...props} />
              ))}
            </ul>
          )}
        </TreeMenu>
      </Menu> */}
    </div>
  );
};
export default MenuNav;
